import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";

export default {
  data() {
    return {
      isLoading: true,
      activeFileIndex: 0,
      folderId: this.$route.params.id,
      isOpen: false,
      files: [],
      hasTransition: false,
    };
  },
  created() {
    this.setSlides();

    EventBus.$on(`image-slider--open`, (activeFileId) =>
      this.openSlider(activeFileId)
    );
  },

  methods: {
    openSlider(activeFileId) {
      this.isOpen = true;
      this.isLoading = true;
      this.hasTransition = false;
      this.setSlides(activeFileId);
    },
    setActiveFile(activeFileId) {
      this.files.forEach((file, index) => {
        if (file.id === activeFileId) {
          this.activeFileIndex = index;
        }
      });

      this.isLoading = false;
    },
    setSlides(activeFileId = 0) {
      let mySpace = 0;
      if (window.location.pathname.split("/")[2] === "myspace") {
        mySpace = 1;
      }

      this.$axios
        .get(`${baseUrl}/folder?folder=${this.folderId}&myspace=${mySpace}`, {
          responseType: "json",
        })
        .then((r) => {
          const newFiles = [];

          r.data.forEach((file, index) => {
            if (file.extension) {
              newFiles.push(file);

              if (file.id === activeFileId) {
                this.activeFileIndex = index;
              }
            }
          });
          this.files = newFiles;

          this.setActiveFile(activeFileId);
        });
    },
    close() {
      this.isOpen = false;
    },
    handleMove(dir) {
      this.hasTransition = true;
      let newIndex = this.activeFileIndex + dir;

      if (newIndex < 0) {
        //go to back
        newIndex = this.files.length - 1;
      }

      if (newIndex > this.files.length - 1) {
        //got to front
        newIndex = 0;
      }

      this.activeFileIndex = newIndex;
    },
  },
  watch: {
    files() {},
    $route() {
      this.folderId = this.$route.params.id;
    },
  },
};
